module.exports = __webpack_public_path__ + "media/images/dividend/ill-bike-mobile-5f03d84bb31e93458e181d653112537a.png";